/* This is generated code, don't alter */
var IfcActionRequestTypeEnum;
(function (IfcActionRequestTypeEnum) {
    IfcActionRequestTypeEnum[IfcActionRequestTypeEnum["EMAIL"] = 0] = "EMAIL";
    IfcActionRequestTypeEnum[IfcActionRequestTypeEnum["FAX"] = 1] = "FAX";
    IfcActionRequestTypeEnum[IfcActionRequestTypeEnum["PHONE"] = 2] = "PHONE";
    IfcActionRequestTypeEnum[IfcActionRequestTypeEnum["POST"] = 3] = "POST";
    IfcActionRequestTypeEnum[IfcActionRequestTypeEnum["VERBAL"] = 4] = "VERBAL";
    IfcActionRequestTypeEnum[IfcActionRequestTypeEnum["USERDEFINED"] = 5] = "USERDEFINED";
    IfcActionRequestTypeEnum[IfcActionRequestTypeEnum["NOTDEFINED"] = 6] = "NOTDEFINED";
})(IfcActionRequestTypeEnum || (IfcActionRequestTypeEnum = {}));
const IfcActionRequestTypeEnumCount = 7;
export { IfcActionRequestTypeEnum, IfcActionRequestTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcActionRequestTypeEnum = new Int32Array([202]);
let prefixSumAddressIfcActionRequestTypeEnum = new Uint32Array([0, 13, 19, 24, 36, 44, 51, 58]);
let slotMapIfcActionRequestTypeEnum = new Int32Array([5, 3, 1, 6, 4, 2, 0]);
let encodedDataIfcActionRequestTypeEnum = (new TextEncoder()).encode(".USERDEFINED..POST..FAX..NOTDEFINED..VERBAL..PHONE..EMAIL.");
let IfcActionRequestTypeEnumSearch = new MinimalPerfectHash(gMapIfcActionRequestTypeEnum, prefixSumAddressIfcActionRequestTypeEnum, slotMapIfcActionRequestTypeEnum, encodedDataIfcActionRequestTypeEnum);
export { IfcActionRequestTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcActionRequestTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcActionRequestTypeEnumSearch, input, cursor, endCursor);
}
